module.exports = __webpack_public_path__ + "img/mastercard-small-icon.d9d04d68.svg";